/* Base translations · W17.8 worksheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): w17_8. */
export const I18N_BASE_W17_8 = {
  en: {
    w17_8: {
      title: "Evaluation and conclusion",
      subtitle: "ISRE 2400 (Revised) 66–85 — data only; no report text is generated here.",
      sufficiencyTitle: "Sufficiency of evidence",
      evidenceSufficient: "Sufficient appropriate evidence has been obtained.",
      limitationDiscussedPh: "Limitation discussed with management / those charged with governance",
      limitationEffectPh: "Effect of the limitation on the conclusion",
      frameworkTitle: "Framework evaluation (para 69)",
      fw: {
        framework_acceptable: "The applicable financial-reporting framework is acceptable.",
        framework_applied_consistently: "The framework has been applied consistently.",
        accounting_policies_selected_and_applied: "Accounting policies have been appropriately selected and applied.",
        disclosures_adequate: "Disclosures are adequate.",
        terminology_appropriate: "The terminology used is appropriate.",
        presentation_and_structure_appropriate: "Overall presentation, structure and content of the FS are appropriate.",
      },
      conclusionTitle: "Conclusion",
      conclusionType: "Conclusion type",
      pickConclusion: "— pick conclusion —",
      conc: { unmodified: "Unmodified", qualified: "Qualified", adverse: "Adverse", disclaimer: "Disclaimer of conclusion" },
      basisRequired: "A basis is required for modified conclusions.",
      pickBasis: "— pick basis —",
      basisOpt: {
        misstatement_material: "Misstatement — material",
        misstatement_pervasive: "Misstatement — material and pervasive",
        inability_material: "Inability to obtain evidence — material",
        inability_pervasive: "Inability to obtain evidence — material and pervasive",
      },
      basisNotePh: "Basis for the modified conclusion (facts, amounts, effect)",
      eom: "Emphasis of matter paragraph",
      eomNotePh: "Note for the Emphasis of matter paragraph",
      om: "Other matter paragraph",
      omNotePh: "Note for the Other matter paragraph",
      signoffsTitle: "Sign-offs",
      role: { preparer: "Preparer", reviewer: "Reviewer", partner: "Partner" },
      pickDate: "— pick date —",
      sign: "Sign",
      signedOk: "Signed.",
      saved: "W17.8 saved.",
      signedBy: "Signed by {name} · {date}",
      notSigned: "Not signed",
      partnerBlockedNotReady: "Partner sign-off is blocked until evidence is confirmed and a conclusion (with basis, if modified) is picked.",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
    },
  },
  ar: {
    w17_8: {
      title: "التقييم والاستنتاج",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح)، الفقرات 66–85 — بيانات فقط؛ لا يُنشأ نص التقرير هنا.",
      sufficiencyTitle: "كفاية الأدلة",
      evidenceSufficient: "تم الحصول على أدلة كافية ومناسبة.",
      limitationDiscussedPh: "المناقشة مع الإدارة / المكلفين بالحوكمة بشأن القيود",
      limitationEffectPh: "أثر القيد على الاستنتاج",
      frameworkTitle: "تقييم الإطار (الفقرة 69)",
      fw: {
        framework_acceptable: "إطار التقرير المالي المطبَّق مقبول.",
        framework_applied_consistently: "طُبِّق الإطار باتساق.",
        accounting_policies_selected_and_applied: "تم اختيار السياسات المحاسبية وتطبيقها بشكل مناسب.",
        disclosures_adequate: "الإفصاحات كافية.",
        terminology_appropriate: "المصطلحات المستخدمة مناسبة.",
        presentation_and_structure_appropriate: "العرض العام والهيكل ومحتوى القوائم المالية مناسبة.",
      },
      conclusionTitle: "الاستنتاج",
      conclusionType: "نوع الاستنتاج",
      pickConclusion: "— اختر نوع الاستنتاج —",
      conc: { unmodified: "غير مُعدَّل", qualified: "متحفَّظ", adverse: "معاكس", disclaimer: "امتناع عن الاستنتاج" },
      basisRequired: "يلزم بيان الأساس للاستنتاجات المُعدَّلة.",
      pickBasis: "— اختر الأساس —",
      basisOpt: {
        misstatement_material: "تحريف — جوهري",
        misstatement_pervasive: "تحريف — جوهري ومنتشر",
        inability_material: "عدم القدرة على الحصول على أدلة — جوهري",
        inability_pervasive: "عدم القدرة على الحصول على أدلة — جوهري ومنتشر",
      },
      basisNotePh: "أساس الاستنتاج المُعدَّل (الوقائع، القيم، الأثر)",
      eom: "فقرة لفت انتباه",
      eomNotePh: "نص فقرة لفت الانتباه",
      om: "فقرة أمر آخر",
      omNotePh: "نص فقرة الأمر الآخر",
      signoffsTitle: "التوقيعات",
      role: { preparer: "المُعِدّ", reviewer: "المُراجِع (فحص)", partner: "الشريك" },
      pickDate: "— اختر التاريخ —",
      sign: "توقيع",
      signedOk: "تم التوقيع.",
      saved: "تم حفظ \u2066W17.8\u2069.",
      signedBy: "وقّعه \u2066{name}\u2069 · {date}",
      notSigned: "بدون توقيع",
      partnerBlockedNotReady: "توقيع الشريك محجوب حتى تأكيد كفاية الأدلة واختيار الاستنتاج (مع الأساس عند التعديل).",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
    },
  },
};

export default I18N_BASE_W17_8;
